import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import { lang, remCss, withRouter } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';
import { ButtonGroup, DatePickerField, MCButton, SelectField, View } from 'components/basic';
import moment from 'moment';
import EarningDetail from 'src/pages/main/Settings/Earning/Detail';
import detailModel from 'src/pages/main/Settings/Earning/Detail/model';
import { convertColumnsForSmallWidth, popupModel, TableLibrary } from 'components/complex';
import StripeForm from 'components/paymentCard/StripeForm';
import PaymentCardList from 'src/components/paymentCard/list';

const statFields = [
  'appointment',
  'appointmentEarnings',
  'treatment',
  'ticket',
  'ticketEarnings',
  'earnings'
];

class Earning extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  getTotalData = () => {
    let items = model.items();
    let total = {};
    statFields.forEach((field) => (total[field] = 0));
    items &&
      items.forEach((item) => {
        total.currency = item.currency;
        statFields.forEach((field) => {
          if (field === 'earnings') {
            let type = model.input('type') || 'all';
            let result =
              type === 'all'
                ? item.appointmentEarnings + item.ticketEarnings
                : item[type + 'Earnings'];
            if (result > 0) total.earnings += result;
          } else {
            if (item[field] > 0) total[field] += item[field];
          }
        });
      });
    return total;
  };

  getPeriod = (item) => {
    let period = model.input('period');
    let label, startDate, endDate;
    startDate = moment(item.day, 'YYYYMMDD');
    if (period === 'week' || period === 'isoWeek') {
      endDate = moment(item.day, 'YYYYMMDD').add(6, 'days');
      let d1 = startDate.format('D MMM, YYYY');
      let d2 = endDate.format('D MMM, YYYY');
      label = d1 + ' - ' + d2;
    } else if (period === 'month') {
      endDate = moment(item.day, 'YYYYMMDD').endOf('month');
      label = startDate.format('MMMM, YYYY');
    } else {
      endDate = moment(item.day, 'YYYYMMDD').endOf('day');
      label = startDate.format('D MMM, YYYY');
    }

    return { label, startDate, endDate };
  };

  onSearchChange = (key, value) => {
    if (value?.toString() === model.input(key)?.toString()) return;
    this.setState({ showDetail: false });
    model.setStateSilent({ [key]: value, pageIndex: 0 });
    model.setListStateSilent({ items: [], total: 0 }, model.getCurrentId());
    model.refresh();
  };
  renderDoctor() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();
    let totalData = this.getTotalData();
    const small = this.props.screenDetail?.innerWidth < 1180;

    const footerStyle = { paddingVertical: remCss(15) };

    const columns = [
      {
        label: small ? null : lang.t(LANG_CONST.date),
        sort: { sortKey: 'date' },
        renderCell: (item) => this.getPeriod(item).label,
        footer: () => (
          <View style={footerStyle}>
            <span>Total:</span>
          </View>
        )
      },
      {
        label: 'Treatments',
        resize: true,
        renderCell: (item) => item.treatment,
        footer: () => (
          <View style={footerStyle}>
            <span>{totalData?.treatment}</span>
          </View>
        )
      },
      {
        label: 'Appointments',
        resize: true,
        renderCell: (item) =>
          `${item.appointment} / ${item.appointmentEarnings.toFixed(2)} ${item.currency}`,
        footer: () => (
          <View style={footerStyle}>
            <span>
              {totalData?.appointment} / {totalData?.appointmentEarnings.toFixed(2)} $
              {totalData?.currency}
            </span>
          </View>
        )
      },
      {
        label: 'Tickets',
        resize: true,
        renderCell: (item) => `${item.ticket} / ${item.ticketEarnings.toFixed(2)} ${item.currency}`,
        footer: () => (
          <View style={footerStyle}>
            <span>
              {totalData?.ticket} / {totalData?.ticketEarnings.toFixed(2)} ${totalData?.currency}
            </span>
          </View>
        )
      },
      {
        label: 'Earnings',
        renderCell: (item) => {
          let type = model.input('type') || 'all';
          let result =
            type === 'all'
              ? (item.appointmentEarnings + item.ticketEarnings).toFixed(2)
              : item[type + 'Earnings'].toFixed(2);
          return `${result} ${item.currency}`;
        },
        footer: () => (
          <View style={footerStyle}>
            <span>{`${totalData?.earnings.toFixed(2)} ${totalData?.currency || ''}`}</span>
          </View>
        )
      },
      {
        label: '',
        width: '100px',
        renderCell: (item) => {
          let label = (
            <MCButton
              outline
              small
              label={LANG_CONST.soon}
              radius
              style={{ width: remCss(75) }}
              quaternary
            />
          );
          if (item.earnings === 0)
            label = (
              <MCButton
                outline
                small
                label={LANG_CONST.zero}
                radius
                style={{ width: remCss(75) }}
              />
            );
          else if (item.paid === true)
            label = (
              <MCButton
                outline
                small
                label={LANG_CONST.paid}
                radius
                style={{ width: remCss(75) }}
              />
            );

          return (
            <View style={{ alignItems: 'flex-end', paddingVertical: remCss(8.5) }}>{label}</View>
          );
        }
      }
    ];
    return (
      <View className={'mc-setting'} style={{ height: '100%' }}>
        <div className={'mc-header'}>
          <div className={'mc-grow mc-wrap mc-flex-20'}>
            <span>
              <ButtonGroup
                medium
                light
                primary
                radius
                flex
                hover
                activeClass='dark'
                onChange={(val) => {
                  this.setState({ showDetail: false });
                  model.changePeriod(val);
                }}
                value={model.getState().period || 'day'}
                options={[
                  { label: 'Day', value: 'day' },
                  { label: 'Week', value: 'isoWeek' },
                  { label: 'Month', value: 'month' }
                ]}
              />
            </span>
            <SelectField
              style={{ marginLeft: remCss(20) }}
              width={remCss(150)}
              options={[
                { value: 'all', label: 'All' },
                { value: 'appointment', label: 'Appointments' },
                { value: 'ticket', label: 'Tickets' }
              ]}
              template={5}
              isClearable={false}
              name={'type'}
              value={model.input('type') || 'all'}
              onChange={(name, val) => {
                model.handleChange(name, val);
                this.setState({ showDetail: false });
              }}
            />
            <span className={'mc-grow'} />
            <div className={'mc-flex'}>
              <DatePickerField
                style={{ minWidth: remCss(200) }}
                template={6}
                icontype={2}
                placeholder={'Start Date'}
                placement={'bottom-center'}
                name={'startDate'}
                value={model.input('startDate')}
                onChange={this.onSearchChange}
                invalid={{}}
              />
              <DatePickerField
                style={{ minWidth: remCss(200) }}
                template={6}
                icontype={2}
                placeholder={'End Date'}
                placement={'bottom-center'}
                name={'endDate'}
                value={model.input('endDate')}
                onChange={this.onSearchChange}
                invalid={{}}
              />
            </div>
          </div>
          <MCButton
            label={LANG_CONST.all}
            dark
            radius
            style={{ width: remCss(80), marginLeft: remCss(20) }}
            onClick={() => {
              detailModel.listState = {};
              if (this.state.showDetail) {
                detailModel.setState({
                  startDate: 0,
                  endDate: 0,
                  period: LANG_CONST.all
                });
                detailModel.refresh();
              } else
                detailModel.setStateSilent({
                  startDate: 0,
                  endDate: 0,
                  period: LANG_CONST.all
                });
              this.setState({ showDetail: true });
            }}
          />
        </div>
        <div
          className={'mc-flex-col mc-grow'}
          style={{ padding: remCss(30), marginTop: remCss(10) }}
        >
          {this.state.showDetail ? (
            <EarningDetail
              screenDetail={this.props.screenDetail}
              onBack={() => {
                this.setState({ showDetail: false });
              }}
            />
          ) : (
            <div style={{ flex: 1, overflow: 'auto' }}>
              <TableLibrary
                loading={loading}
                noResults={noResults}
                searchQuery={searchQuery}
                sortBy={model.state.sortBy}
                selectedPage={model.state.pageIndex}
                total={total}
                limit={model.listLimit}
                showPagination={false}
                otherProps={{
                  row: () => ({
                    className: 'mc-hover-row'
                  })
                }}
                onRowClick={(item) => {
                  const period = this.getPeriod(item);
                  detailModel.listState = {};
                  detailModel.setStateSilent({
                    startDate: period.startDate,
                    endDate: period.endDate,
                    period: period.label
                  });
                  this.setState({ showDetail: true });
                }}
                data={items}
                columns={small ? convertColumnsForSmallWidth(columns) : columns}
                showHeader={!small}
              />
            </div>
          )}
        </div>
      </View>
    );
  }

  renderPatient() {
    return (
      <View className={'mc-setting'} style={{ height: '100%' }}>
        <div className={'mc-header'}>
          <div className={'mc-title mc-grow'}>{lang.t(LANG_CONST.titles.cards)}</div>
          <MCButton
            primary
            dark
            radius
            onClick={() =>
              popupModel.setActivePopup('add_card', {
                active: true,
                component: StripeForm
              })
            }
          >
            {lang.t('Add new card')}
          </MCButton>
        </div>
        <div className={'mc-flex-col mc-grow mc-p30'}>
          <EarningDetail
            screenDetail={this.props.screenDetail}
            headerEl={
              <div className={'mc-payment-card-container mc-mb20 mc-p20'}>
                <PaymentCardList />
              </div>
            }
          />
        </div>
      </View>
    );
  }

  render() {
    return model.state.user?.isDoctor ? this.renderDoctor() : this.renderPatient();
  }
}

export default withRouter(Earning);
